import { Navigate, Outlet } from "react-router";

export const AdminGuard = () => {
  const adminToken = localStorage.getItem("adminToken");

  if (!adminToken) {
    return <Navigate replace to="/admin/login" />;
  }

  return <Outlet />;
};
